import React from 'react';
import './Chapters.scss';

function Chapter4() {
  return (
    <section className="chapter">
      <h3 className="chapter__title">Solving an Unusual Supply-Demand Challenge</h3>
      <p className="chapter__paragraph">
        With FareShare, there is one unique challenge: “Most companies have an element of control
        over their supply, but FareShare usually does not know what donations will arrive on a given
        day,” Nummedal says. “That means we need to help FareShare GM predict both supply and demand
        and then marry them up, which is quite a peculiar problem and something that we don’t often
        see.”
      </p>
      <p className="chapter__paragraph">
        In developing its AI applications, Peak benefits from the flexibility of the processing
        power available on AWS. “AWS with Intel technologies makes it simple for data scientists to
        simply select from a drop-down menu how much memory, processing power, CPUs, or GPUs they
        need to run a particular analysis,” Nummedal says. “Peak’s data scientists use AWS to create
        environments in which we can build models that turn data into actionable insights that
        generate business value for our customers. There are loads of AWS features we use that
        underpin our platform. Personally, that’s been a game-changer for me.”
      </p>
      <p className="chapter__paragraph">
        Working closely with FareShare GM to pilot initial solutions, Peak discovered an important
        metric that they hadn’t seen among their existing customer base before: the idea of fairness
        in distribution. Specifically, the idea that donations should be distributed according to
        need. So, if a certain area accounted for 30% of hunger in the region, that area should
        ideally receive 30% of the food that FareShare GM distributes. Peak added fairness to its
        list of key performance indicators (KPIs) that its AI application would optimize for
        FareShare GM’s distribution activities. “A lot of people in both Peak’s data science team
        and the wider community are looking to leverage AI’s immense computational power for good,”
        says Nummedal. “We can harness this power not just to drive profit, but also to help people
        in need. Personally, that gives me a great sense of purpose.”
      </p>
    </section>
  );
}

export default Chapter4;
